import React from "react";
import { Outlet } from "react-router-dom";
import ProfileTabs from "./ProfileTabs";

export const InsProfile = () => {
    return (
        <div className="min-h-screen bg-gray-100 flex justify-center items-start py-8 px-4">
            <div className="w-full max-w-5xl bg-white rounded-xl shadow-md p-6">
                {/* TOP BAR */}
                <div className="w-full">
                    <ProfileTabs />
                </div>
                {/* PAGE CONTENT */}
                <div className="mt-8">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};
